import React, { useRef } from "react";
import classes from "./SliderBox.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import portfolioData from "../../data/portfolio.json";

const NextArrow = () => {
  return <div>next</div>;
};

const SliderBox = () => {
  const sliderRef = useRef(null); // Ref 생성

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 3,
    nextArrow: <></>, // 다음 화살표 제거
    prevArrow: <></>, // 이전 화살표 제거
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={classes["slider-box"]}>
      <Slider ref={sliderRef} {...settings}>
        {portfolioData.map((item) => {
          return (
            <div key={item.idx} className={classes["slider-item"]}>
              <div>
                <h3 className={classes["slider-item-title"]}>{item.title}</h3>
                <p className={classes["slider-item-description"]}>
                  {item.description}
                </p>
                <ol className={classes["slider-item-tags"]}>
                  {item.tags.map((tag, idx) => {
                    return <li key={idx}>#{tag}</li>;
                  })}
                </ol>

                <div className={classes["slider-links-box"]}>
                  <ul>
                    {item.links.map((link, idx) => {
                      return (
                        <li key={idx}>
                          <a href={link.url} target="_blank">{link.type}</a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
      <button
        onClick={() => sliderRef.current.slickNext()}
        className={classes["slider-next-btn"]}
      >
        <span className="material-icons-round">arrow_forward_ios</span>
      </button>
    </div>
  );
};

export default SliderBox;
